import React, { useState, useEffect } from "react"
import styled from "styled-components"

import { Row, Col, Card, InputGroup, FormControl } from "react-bootstrap"
import Image from "gatsby-image"

export let LogoClevermeets = props => {
  return (
    <>
      <section>
        <Image fluid={props.fluidImg} alt={props.alt}></Image>
      </section>
    </>
  )
}

export default LogoClevermeets
const DivLogo = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 3rem;
  padding-left: 2rem;
  padding-right: 2rem;
  img {
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
    border: 0;
    height: auto;
    object-fit: scale-down !important;
  }
`
